<template>
  <div>
  <div class="uk-section">
      <div class="uk-container uk-container-small">
      <h1>{{ matches[0].homeTeam.name }} vs {{ matches[0].awayTeam.name }}</h1>
      <h3 style="text-align: center; margin: 0; padding: 0; font-size: 40px;" v-if="matches[0].isFinished">
        {{ matches[0].homeScore }} vs {{ matches[0].awayScore }}
      </h3>
        <vue-markdown-it
          v-if="matches[0].veto"
          :source="matches[0].veto"
          id="editor"
        />
        <h3 v-if="matches[0].matchtickers">Liveoppdateringer</h3>
        <div v-for="matchticker in matches[0].matchtickers" :key="matchticker.id">
          <div style="float: left; margin-top: 32px;" uk-icon="icon: info; ratio: 2"></div>
          <div class="uk-animation-slide-right-medium">
              <div class="updateLine" style="float: left;">
                  <strong>[{{ moment(matchticker.created_at).format("HH:mm") }}]</strong> {{ matchticker.body }}
              </div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css">
  .updateLine {
    height: auto;
    padding: 15px 15px;
    margin-bottom: 5px;
    box-shadow:
    0 1.8px 1.2px rgba(0, 0, 0, 0.034),
    0 3.7px 3.3px rgba(0, 0, 0, 0.048),
    0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 12.3px 7.9px rgba(0, 0, 0, 0.072),
    0 31.8px 23.4px rgba(0, 0, 0, 0.086),
    0 90px 70px rgba(0, 0, 0, 0.12);
    min-width: 1%;
    width: fit-content;
    margin: 25px;
    background: white;
    border-radius: 5px;
    color: #0f1923;
  }
</style>

<script>
var moment = require("moment");
import VueMarkdownIt from "vue-markdown-it";
import gql from "graphql-tag";

export default {
  data() {
    return {
      matches: {},
      moment: moment,
      api_url: process.env.VUE_APP_STRAPI_API_URL,
      routeParam: this.$route.params.id
    };
  },
  name: "Match",
  components: {
    VueMarkdownIt
  },
  apollo: {
    matches: {
      query: gql`
        query Matches($slug: String!) {
            matches(where: { slug: $slug }) {
            id
            slug
            tournament {
              name
              slug
            }
            homeTeam {
              name
              slug
              logo {
                url
              }
            }
            awayTeam {
              name
              slug
              logo {
                url
              }
            }
            veto
            matchtickers(sort: "id:desc") {
              id
              body
              icon
              created_at
              author {
                username
              }
            }
            isFinished
            homeScore
            awayScore
            maps: match_maps {
              map
              homeScore
              awayScore
            }
          }
        }
      `,
      pollInterval: 3000, // ask for updated info every 10 seconds
      variables() {
          console.log('Test:' + this.routeParam)
        return {
          slug: this.routeParam
        };
      }
    }
  }
};
</script>